<template>
    <img class="mx-auto w-auto max-h-128 object-cover rounded-lg shadow md:col-span-1" :src="content.src" :alt="content.alt">
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
    content: {
        type: Object,
        required: true
    }
})
</script>